import { FilterNames } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';

export const FILTERS_BY_SOURCE_KEY = {
    activityCodes: [
        {
            [FilterNames.ACTIVITY_CODES]: (source) =>
                source?.activityCodes?.filter((item) => !item.isExclude).map((i) => i.name),
        },
        {
            [FilterNames.ACTIVITY_CODES_EXCLUDE]: (source) =>
                source?.activityCodes?.filter((item) => item.isExclude).map((i) => i.name),
        },
    ],

    tags: [
        {
            [FilterNames.TAG_CARD_BOARD]: (source) =>
                source?.tags?.filter((item) => !item.isExclude).map((i) => i.name),
        },
        {
            [FilterNames.TAG_CARD_BOARD_EXCLUDE]: (source) =>
                source?.tags?.filter((item) => item.isExclude)?.map((i) => i.name),
        },
    ],

    milestoneFragnet: [{ [FilterNames.FRAGNET_SEARCH]: (source) => source.milestoneFragnet }],

    wbs: [{ [FilterNames.WBS_SEARCH]: (source) => source.wbs }],
};

export const PILLS_BY_SOURCE_KEY = {
    activityCodes: [
        {
            activityCodes: (source) => source?.activityCodes?.filter((item) => !item.isExclude).map((i) => i.name),
        },
        {
            activityCodesExclude: (source) =>
                source?.activityCodes?.filter((item) => item.isExclude).map((i) => i.name),
        },
    ],
    milestoneFragnet: [{ milestoneFragnet: (source) => source?.milestoneFragnet }],
    wbs: [{ wbs: (source) => source?.wbs }],
    tags: [
        { tags: (source) => source?.tags?.filter((item) => !item.isExclude).map((i) => i.name) },
        { tagsExclude: (source) => source?.tags?.filter((item) => item.isExclude).map((i) => i.name) },
    ],
    statusFilter: [{ statusFilter: (source) => source?.statusFilter?.map((item) => item.label) }],
    isCriticalPath: [{ isCriticalPath: (source) => source?.isCriticalPath }],
};
